
export const API_URL = "https://okr.ssdntech.com";







